import { useQuery, UseQueryOptions } from 'react-query';
import { composeQueryOpts } from '~/src/entities/utils';
import { APIError } from '~/src/utils/error';
import contentPublishingService, {
  ContentFilterOptionsResponse,
} from '~/src/services/api/contentPublishingService';

const keys = {
  contentFilterOptions: () =>
    ['contentPublishing', 'contentFilterOptions'] as const,
};

export const useContentFilterOptions = (
  options: UseQueryOptions<ContentFilterOptionsResponse, APIError> = {},
) => {
  return useQuery(
    composeQueryOpts(options, {
      queryKey: keys.contentFilterOptions(),
      queryFn: () => contentPublishingService.getContentFilterOptions(),
      staleTime: 0,
    }),
  );
};
